<template>
  <div id="app">
    <router-view />
    <IdleModal v-if="isIdle" />
  </div>
</template>

<script>
import IdleModal from "@/components/IdleModal.vue";
import { mapState } from "vuex";
export default {
  components: {
    IdleModal
  },
  created() {
    this.getPrefersColorScheme();
    if(this.prefersColorScheme) {
      this.prefersColorScheme.addEventListener('change', e => this.onPrefersColorSchemeChange(e));
    }
  },
  beforeDestroy () {
    if(this.prefersColorScheme) {
      this.prefersColorScheme.removeEventListener('change', e => this.onPrefersColorSchemeChange(e));
    }
  },
  data() {
    return {
      prefersColorScheme: null,
    }
  },
  computed: {       
    ...mapState({
        isIdle: state => state.idleVue.isIdle,
    }),
    themeMode: {
      get() {
        return this.$root.themeMode;
      },
      set(value) {
        this.$root.themeMode = value;
      }
    },
	},
  methods: {
    getPrefersColorScheme() {
      if(window.matchMedia) {
        this.prefersColorScheme = window.matchMedia('(prefers-color-scheme: dark)');
        if (this.prefersColorScheme.matches) {
          this.themeMode = 'dark';
        } else {
          this.themeMode = 'light';
        }
      } else {
        this.themeMode = 'light';
      }
      console.log(`Using ${this.themeMode} theme mode`);
    },
    onPrefersColorSchemeChange(e) {
        const newColorScheme = e.matches ? "dark" : "light";
        this.themeMode = newColorScheme;
        console.log(`theme changed to ${this.themeMode} mode`);
    },
  },
}
</script>

<style lang="scss">
  @import "@/scss/consumergrav.scss";
  @import "../node_modules/bootstrap/scss/bootstrap";
  @import "../node_modules/bootstrap-vue/src/index.scss";
  @import '../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  @import '../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  @import '../node_modules/@syncfusion/ej2-popups/styles/material.css';
  @import "../node_modules/@syncfusion/ej2-vue-calendars/styles/material.css";
</style>
